import Sidebar from '@nkr/components/layout/sidebar';
import { BaseGridWrapper } from '@nkr/components/styles';
import { IQaCron } from '@nkr/store/index';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { GridReadyEvent, RowDataChangedEvent, RowHeightParams } from 'ag-grid-community';
import { ColDef, ICellRendererParams, IHeaderParams } from 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
import { useMemo, useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import styled from 'styled-components';
import TaskVariableForm from './task-variable-form';

const GridWrapper = styled(BaseGridWrapper)`
    .list-cell {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

interface IProps {
    data: IQaCron[],
    onConfirmRunManually: (id: number, alternate: boolean) => void
}

const Grid = (props: IProps) => {
    const [configValue, setConfigValue] = useState<string>('');

    const onGridReady = (e: GridReadyEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onRowDataChanged = (e: RowDataChangedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const columns: ColDef[] = [
        {
            colId: 'taskId',
            field: 'taskId',
            width: 100,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params} >Task ID</SortableHeaderComponent>,
        },
        {
            colId: 'description',
            field: 'description',
            width: 100,
            sort: 'asc',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params} >Description</SortableHeaderComponent>,
        },
        {
            colId: 'group',
            field: 'groupName',
            width: 50,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params} >Product</SortableHeaderComponent>,
        },
        {
            colId: 'testVariableKey',
            field: 'testVariableKey',
            width: 50,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params} >Alt Run Config</SortableHeaderComponent>,
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IQaCron;
                return (
                    <a href='#' onClick={(e) => { e.preventDefault(); setConfigValue(data.testVariableKey); }}>{data.testVariableKey}</a>
                );
            }
        },
        {
            colId: 'actions',
            cellClass: 'action-menu',
            width: 35,
            sortable: false,
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params} >Actions</SortableHeaderComponent>,
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IQaCron;

                return (
                    <div>
                        <Button bsStyle='primary' bsSize='xs' style={{ width: 85, marginRight: data.alternateRun != null ? 5 : 0 }} onClick={() => props.onConfirmRunManually(data.id, false)}>Run</Button>

                        {data.alternateRun != null && (
                            <OverlayTrigger placement='bottom' trigger={['hover', 'hover']} overlay={<Tooltip id={'tt-' + data.id}>{data.alternateRun.description}</Tooltip>}>
                                <Button bsStyle='primary' bsSize='xs' style={{ width: 85 }} onClick={() => props.onConfirmRunManually(data.id, true)}>Run Alternate</Button>
                            </OverlayTrigger>
                        )}
                    </div>
                );
            }
        },
    ];

    const columnDefs = useMemo(() => columns, [configValue]);
    const rowData = useMemo(() => props.data, [props.data]);

    return (<>
        <GridWrapper className='ag-theme-bootstrap' style={{ height: '83vh' }}>
            <AgGridReact
                defaultColDef={{
                    headerClass: 'list-header',
                    cellClass: 'list-cell',
                    sortable: true
                }}
                columnDefs={columnDefs}
                rowData={rowData}
                rowHeight={35}
                suppressContextMenu={true}
                onGridReady={onGridReady}
                onRowDataChanged={onRowDataChanged}
                onGridColumnsChanged={params => params.api.sizeColumnsToFit()}
                onGridSizeChanged={params => params.api.sizeColumnsToFit()}
            />
        </GridWrapper>

        <Sidebar title="Alternate Run Configuration" isOpen={configValue?.length > 0} onClose={() => setConfigValue('')}>
            <TaskVariableForm variableKey={configValue} onClose={() => setConfigValue('')} />
        </Sidebar>
    </>
    );
}

export default Grid;